



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";
import DialogCancelBooking from "../general/DialogCancelBooking.vue";

import UserJson from "../../shared/UserJson";
import GroupBookingProgramJson from "../../shared/GroupBookingProgramJson";
import GroupBookingJson from "../../shared/GroupBookingJson";
import { GroupBookingStatus } from "../../shared/GroupBookingStatus";
import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";

import { validateGroupBookingJsonManagement } from "../../shared/GroupBookingJson";
import { validateGroupBookingJsonManagementAdd } from "../../shared/GroupBookingJson";
import { validateGroupBookingJsonManagementReadyToOffer } from "../../shared/GroupBookingJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import { Gender } from "../../shared/Gender";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import { UserPermissionType } from "../../shared/UserPermissionType";
import UserPermissionJson from "../../shared/UserPermission";

import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";

type keysForCachedData = {
  [key in keyof Pick<GroupBookingJson, "desiredDateTime" | "beginDateTime" | "endDateTime">]: string;
};

type keysForCachedPrices = {
  [key in keyof Pick<GroupBookingJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "GroupsBookingDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    Loading,
    InvoiceInfoDetails,
    DialogCancelBooking,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    GroupsBookingStatusNames: Object,
    bookingId: Number,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      Gender: Gender,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      defaultGroupBookingHours: {
        halfDay: 3,
        wholeDay: 6,
      },
      GroupBookingStatus: GroupBookingStatus,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      detailsMode: "",
      selectedBookingId: null as number | null,
      groupBookingPrograms: null as GroupBookingProgramJson[] | null,
      selectedGroupBookingProgramId: null as number | null,
      bookingDetails: null as GroupBookingJson | null,
      selectedProgramTemplates: [] as GroupBookingProgramJson[],
      selectedPriceInfoProgramId: null as number | null,
      cachedDates: {
        desiredDateTime: "",
        beginDateTime: "",
        endDateTime: "",
      } as keysForCachedData,
      cachedTimes: {
        desiredDateTime: "",
        beginDateTime: "",
        endDateTime: "",
      } as keysForCachedData,
      cachedPrices: {
        price: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      useSepaMandate: false as boolean,
      hasChanges: false,
      showHints: {
        statusChanged: false as boolean,
        desiredTime: false as boolean,
        changedDesiredDateTime: false as boolean,
        changedLunch: false as boolean,
        changedWholeDay: false as boolean,
        changedEstimatedChildrenCount: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<GroupBookingJson> | null,
      submitValidation: false as boolean,
      showDialogCancelBooking: false as boolean,
      loadingNextup: false as boolean,
      loadingGeneral: false as boolean,
      loadingOffer: false as boolean,
    };
  },
  created() {
    this.initGroupBookingDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedDates();
  },
  methods: {
    initGroupBookingDetails() {
      this.selectedBookingId = this.bookingId;

      this.loadGroupPrograms();
      this.loadGroupBookingDetails();
      this.selectDetailsMode(this.mode);
      this.loadAllUsers();
    },

    setCachedData() {
      this.setCachedDates();
      this.setCachedTimes();
      this.setCachedPrices();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadGroupBookingDetails() {
      if (this.selectedBookingId != null) {
        try {
          this.bookingDetails = await this.restClient.getGroupBooking(this.selectedBookingId);

          if (this.bookingDetails != null && this.bookingDetails.sepaMandate != null) {
            this.useSepaMandate = true;
          }
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.bookingDetails = {
          ID: null,
          desiredDateTime: "",
          beginDateTime: "",
          endDateTime: "",
          remarks: "",
          isLunchIncluded: false,
          lunchPortionAmount: null,
          isWholeDay: false,
          staffId: null,
          customer: this.getDefaultCustomer(),
          state: GroupBookingStatus.requested,
          programTitle: "",
          programDescription: "",
          estimatedChildrenCount: 1,
          estimatedChildrenAge: "",
          price: 0,
          cancellationFee: 0,
          cancellationRemarks: "",
          cancellationReason: "",
          sepaMandate: null,
          invoiceInfos: null,
        };
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      if (this.bookingDetails != null) {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.bookingDetails.customer.guardianFirstName,
          accountHolderLastName: this.bookingDetails.customer.guardianLastName,
          addressStreet: this.bookingDetails.customer.addressStreet,
          addressZip: this.bookingDetails.customer.addressZip,
          addressCity: this.bookingDetails.customer.addressCity,
          addressCountry: this.bookingDetails.customer.addressCountry,
          IBAN: "",
          BIC: "",
        };
      } else {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "Deutschland",
          IBAN: "",
          BIC: "",
        };
      }
    },

    async reloadGroupBookingDetails() {
      if (this.selectedBookingId != null) {
        this.bookingDetails = null;
        try {
          this.bookingDetails = await this.restClient.getGroupBooking(this.selectedBookingId);

          this.setCachedData();

          this.$nextTick(() => {
            this.hasChanges = false;
          });
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadGroupPrograms() {
      this.groupBookingPrograms = null;

      if (this.restClient != null) {
        try {
          this.groupBookingPrograms = await this.restClient.getGroupBookingPrograms();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAllUsers() {
      this.allUsers = null;
      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    toggleUseSepaMandate() {
      if (this.bookingDetails != null) {
        if (this.useSepaMandate) {
          this.bookingDetails.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.bookingDetails.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    selectDetailsMode(mode: string) {
      this.resetShowHints();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Anfrage hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Anfrage/Buchung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Anfrage/Buchung";
          this.editable = false;
          break;
      }
    },

    resetShowHints() {
      let k = this.showHints;
      let i: keyof typeof k;

      for (i in this.showHints) {
        this.showHints[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        //fliegt viell. komplett raus wegen reload
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.reloadGroupBookingDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.reloadGroupBookingDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    //START set cached data

    setCachedDates() {
      if (this.bookingDetails != null) {
        let k = this.cachedDates;
        let i: keyof typeof k;

        for (i in this.cachedDates) {
          if (this.bookingDetails[i] != "") {
            var d = new Date(this.bookingDetails[i]);

            if (this.supportsDatePicker) {
              this.cachedDates[i] = DateFormatter.formatISODate(d);
            } else {
              if (d != null) {
                this.cachedDates[i] = DateFormatter.formatDateMedium(d);
              }
            }

            //this.cachedDates[i] = this.DateFormatter.formatISODate(new Date(this.bookingDetails[i]))
          }
        }
      }
    },

    setCachedTimes() {
      if (this.bookingDetails != null) {
        let k = this.cachedTimes;
        let i: keyof typeof k;

        for (i in this.cachedTimes) {
          if (this.bookingDetails[i] != "") {
            this.cachedTimes[i] = DateFormatter.formatTime(new Date(this.bookingDetails[i]));
          }
        }
      }
    },

    setCachedPrices() {
      if (this.bookingDetails != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          let price = this.bookingDetails[i]
            ?.toString()
            .padStart(3, "0")
            .replace(/(\d{2,2})$/g, ",$1")
            .replace("NaN", "");

          if (price !== undefined) {
            this.cachedPrices[i] = price;
          }
        }
      }
    },

    //END set cached data

    //START set input data (where data be cached)

    formatCachedDateTimeAndSet(key: keyof keysForCachedData) {
      if (this.bookingDetails != null) {
        //date
        if (this.cachedDates[key] != "") {
          let date = "";

          if (this.supportsDatePicker) {
            date = DateFormatter.formatUSDate(new Date(this.cachedDates[key]));
          } else {
            if (this.cachedDates[key].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedDates[key]);

              if (d != null) {
                date = DateFormatter.formatUSDate(d);
              }
            }
          }

          //time
          let time = this.cachedTimes[key].replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

          //if (time.match(/^\d{2,2}:\d{2,2}$/g)) {
          this.cachedTimes[key] = time;

          if (isNaN(new Date(date).getTime())) {
            //no valid date
            this.bookingDetails[key] = "";
          } else {
            let dateTime = new Date(date);

            if (this.cachedTimes[key] != "") {
              //let time = DateFormatter.formatTime(new Date(this.workshopDetails.registrationBeginDateTime))

              dateTime = new Date(date + " " + this.cachedTimes[key]);
            }

            this.bookingDetails[key] = DateFormatter.formatISODateTime(dateTime);
            this.cachedTimes[key] = DateFormatter.formatTime(new Date(this.bookingDetails[key]));
            this.showHints.desiredTime = false;
          }
        } else {
          this.cachedTimes[key] = "";
          this.showHints.desiredTime = true;
        }
      }
    },

    formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
      if (this.bookingDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.bookingDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data

    setGroupProgramInfos() {
      if (
        this.selectedGroupBookingProgramId != null &&
        this.bookingDetails != null &&
        this.groupBookingPrograms != null
      ) {
        let selectedProgramInfo = this.groupBookingPrograms.find(
          (i: any) => this.selectedGroupBookingProgramId == i.ID
        );

        if (selectedProgramInfo !== undefined) {
          this.bookingDetails.programTitle = selectedProgramInfo.title;
          this.bookingDetails.programDescription = selectedProgramInfo.description;
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.bookingDetails != null) {
        this.validation = validateGroupBookingJsonManagementReadyToOffer(this.bookingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //program templates

    clickedProgramTemplate(programId: number) {
      const programInfo = this.getGroupBookingProgramById(programId);

      if (programInfo !== undefined) {
        this.addProgramTemplateToSelected(programInfo);
        this.addProgramTemplateToDescription(programInfo);
        this.addProgramTemplateToTitle(programInfo);
      }
    },

    addProgramTemplateToSelected(programInfo: GroupBookingProgramJson) {
      if (!this.selectedProgramTemplates.find((i: any) => i.ID == programInfo.ID)) {
        this.selectedProgramTemplates.push(programInfo);
      }
    },

    addProgramTemplateToDescription(programInfo: GroupBookingProgramJson) {
      if (this.bookingDetails != null) {
        let addText = "";
        if (this.bookingDetails.programDescription != "") {
          addText += "\n\n";
        }
        addText += programInfo.description;
        this.bookingDetails.programDescription += addText;
      }
    },

    addProgramTemplateToTitle(programInfo: GroupBookingProgramJson) {
      if (this.bookingDetails != null) {
        let addText = "";
        if (this.bookingDetails.programTitle != "") {
          addText += ", ";
        }
        addText += programInfo.title;
        this.bookingDetails.programTitle += addText;
      }
    },

    async addNewBooking() {
      if (this.bookingDetails != null) {
        this.loadingGeneral = true;

        //set begin and end dateTime
        this.setBeginAndEndDateTime();

        this.validation = validateGroupBookingJsonManagementAdd(this.bookingDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.bookingDetails = await this.restClient.addGroupBooking(this.bookingDetails);
            alert("Die Gruppen Anfrage wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              if (this.bookingDetails != null) {
                this.selectedBookingId = this.bookingDetails.ID;
              }

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Die Gruppen Anfrage konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveBooking() {
      if (this.hasChanges) {
        if (await this.saveBookingDetails()) {
          this.stopEditMode();
        }
      } else {
        alert("Es wurden keine Änderungen vorgenommen.");
      }
    },

    async saveBookingDetails() {
      if (this.bookingDetails != null) {
        this.loadingGeneral = true;

        //todo ###START
        //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
        this.validation = validateGroupBookingJsonManagement(this.bookingDetails);
        //todo ###END

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              let updatedBookingDetails = await this.restClient.updateGroupBooking(this.bookingDetails);

              this.hasChanges = false;
              this.loadingGeneral = false;

              //TODO: Validation error loest alert auch aus -> prüfen
              alert("Die Änderungen wurden erfolgreich gespeichert.");

              return true;
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
              return false;
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          return false;
        }
      }
    },

    async deleteBooking() {
      if (this.bookingDetails != null && this.selectedBookingId != null) {
        let c = confirm("Wollen Sie diesen Eintrag wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteGroupBooking(this.selectedBookingId);
              this.closeDetails();
              alert("Der Eintrag wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async confirmCancelBooking() {
      if (!this.hasChanges) {
        if (this.bookingDetails != null && this.bookingDetails.ID != null) {
          let c = confirm(
            "Wollen Sie die Absage per E-Mail bestätigen? Die Anfrage/Buchung wird unter Berücksichtigung der Stornierungsgebühr (€ " +
              this.getFormatPrice(this.bookingDetails.cancellationFee) +
              ") abgesagt."
          );
          if (c == true) {
            this.loadingGeneral = true;

            if (this.restClient != null) {
              try {
                await this.restClient.confirmCancelGroupBooking(this.bookingDetails.ID);
                this.closeDetails();
                alert("Die Stornierung der Anfrage/Buchung wurde erfolgreich bestätigt.");

                this.loadingGeneral = false;
              } catch (e) {
                alert(e.message);

                this.loadingGeneral = false;
              }
            }
          } else {
            //do nothing
          }
        }
      } else {
        alert("Bitte speichern Sie zuvor die letzten Änderungen.");
      }
    },

    async cancelBooking() {
      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.bookingDetails != null && this.bookingDetails.ID != null) {
        let c = confirm(
          "Wollen Sie die Anfrage/Buchung wirklich stornieren? Die Anfrage/Buchung wird unter Berücksichtigung der Stornierungsgebühr (€ " +
            this.getFormatPrice(this.bookingDetails.cancellationFee) +
            ") abgesagt."
        );
        if (c == true) {
          this.loadingGeneral = true;

          if (this.restClient != null) {
            try {
              await this.restClient.cancelGroupBooking(this.bookingDetails.ID);
              this.closeDetails();
              alert("Die Anfrage/Buchung wurde erfolgreich abgesagt.");

              this.loadingGeneral = false;
            } catch (e) {
              alert(e.message);

              this.loadingGeneral = false;
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async sendBookingOffer() {
      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.bookingDetails != null && this.selectedBookingId != null) {
        this.loadingOffer = true;

        this.validation = validateGroupBookingJsonManagementReadyToOffer(this.bookingDetails);

        if (this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.offerGroupBooking(this.selectedBookingId);
              alert("Es wurde ein Angebot an den Kunden gesendet.");
              this.hasChanges = false;

              this.loadingOffer = false;
              this.stopEditMode();
            } catch (e) {
              this.loadingOffer = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingOffer = false;
          alert("Das Angebot konnte nicht gesendet werden, da Angaben fehlen.");
        }
      }
    },

    async sendBookingConfirmation() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.confirmGroupBooking(this.selectedBookingId);
          alert("Es wurde eine Buchungsbestätigung an den Kunden gesendet.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    setBeginAndEndDateTime() {
      if (this.bookingDetails != null) {
        //set beginDateTime
        this.bookingDetails.beginDateTime = this.bookingDetails.desiredDateTime;

        //set endDateTime
        const beginDateTimeDate = new Date(this.bookingDetails.desiredDateTime);

        var durationTime = 0;
        if (this.bookingDetails.isWholeDay) {
          durationTime = this.defaultGroupBookingHours.wholeDay;
        } else {
          durationTime = this.defaultGroupBookingHours.halfDay;
        }

        let beginHours = beginDateTimeDate.getHours();
        let endDateTimeDate = beginDateTimeDate.setHours(beginHours + durationTime);

        this.bookingDetails.endDateTime = DateFormatter.formatISODateTime(new Date(endDateTimeDate));
      }
    },

    setLunchPortionAmount() {
      if (this.bookingDetails != null) {
        if (this.bookingDetails.isLunchIncluded) {
          this.bookingDetails.lunchPortionAmount = this.bookingDetails.estimatedChildrenCount;
        } else {
          this.bookingDetails.lunchPortionAmount = null;
        }
      }
    },

    // print
    printBookingDetails() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    getGroupBookingProgramById(programId: number) {
      if (this.groupBookingPrograms != null) {
        let info = this.groupBookingPrograms.find((i: any) => i.ID == programId);

        return info;
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    bookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionGroupsManagement: function () {
      return checkPermission(this.loginUser, 2, UserPermissionType.moduleGroups);
    },

    permissionPaymentsManagement: function () {
      return checkPermission(this.loginUser, 2, UserPermissionType.modulePayments);
    },

    nextupEditable: function () {
      if (this.bookingDetails != null) {
        let nextupStates = [this.GroupBookingStatus.offerToCustomer];

        if (this.detailsMode != "add" && nextupStates.indexOf(this.bookingDetails.state) >= 0) {
          return true;
        } else {
          return false;
        }
      }
    },

    sortedUser: function (): { groupUser: UserJson[]; otherUser: UserJson[] } {
      var res: { groupUser: UserJson[]; otherUser: UserJson[] } = { groupUser: [], otherUser: [] };

      if (this.allUsers != null) {
        for (let user of this.allUsers) {
          if (user.userPermissions.find((i: UserPermissionJson) => i.type == "moduleGroups")) {
            res.groupUser.push(user);
          } else {
            res.otherUser.push(user);
          }
        }
      }

      return res;
    },

    getStaff: function (): UserJson | undefined | null {
      if (this.allUsers != null) {
        return this.allUsers.find((item: UserJson) => {
          if (this.bookingDetails != null) {
            return item.ID == this.bookingDetails.staffId;
          }
        });
      }
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            return this.bookingDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            this.bookingDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
